import { defaultTheme } from 'gd-design-library';

const commonCardStyles = {
  borderRadius: '0.5rem',
  overflow: 'hidden',
  '&:hover': {
    boxShadow: 'none'
  }
};

export const card = {
  ...defaultTheme.card,
  default: {
    ...commonCardStyles
  }
  // Vertical: {
  //   ...defaultTheme.card.Vertical,
  //   default: {
  //     ...defaultTheme.card.Vertical.default,
  //     ...commonCardStyles
  //   }
  // },
  // Horizontal: {
  //   ...defaultTheme.card.Horizontal,
  //   default: {
  //     ...defaultTheme.card.Horizontal.default,
  //     ...commonCardStyles
  //   }
  // }
};
